import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Card, Skeleton } from "antd";

const RoleDetails = (props) => {
  const { cardTitleStyle, hasEditAccess, userDetails, isLoading } = props;
  return (
    <Card
      title={<span style={cardTitleStyle}>Role</span>}
      bordered={false}
      extra={
        hasEditAccess && userDetails?._id ? (
          <Link to={`/user-create/${userDetails?._id}?step=role`}>Edit</Link>
        ) : null
      }
    >
      {" "}
      {isLoading ? (
        <Skeleton active title={false} paragraph={{ rows: 4 }} />
      ) : (
        <>
          <p>Main Role</p>
          <h4>{userDetails?.role?.main_role_id?.main_role_name ?? null}</h4>
          <p>Role</p>
          <h4>{userDetails?.role?.role_name ?? null}</h4>
        </>
      )}
    </Card>
  );
};

RoleDetails.propTypes = {};

export default RoleDetails;
